module.exports = __webpack_public_path__ + "static/img/draw.d7a4a7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/btn/draw.png
// module id = jaKq
// module chunks = 1